import React, { useState, useEffect } from 'react';
import { API_URL, customStyles, secret_key, storedData } from '../components/Constants';
import InfiniteScroll from 'react-infinite-scroll-component';
import axios from 'axios';
import Modal from 'react-modal';
import Select from 'react-select';
import Swal from "sweetalert2";
import CryptoJS from "crypto-js";
import { useNavigate } from 'react-router-dom';
import loading1 from "../assets/loading.gif"

const customStylesforUnits = {
  content: {
    top: '30%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    minWidth: '350px',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    border: 'none',
    marginTop: '40px'
  },
};

function UserManagement() {
  const [searchTerm, setSearchTerm] = useState('');
  const [users, setUsers] = useState([]);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [companies, setCompany] = useState([]);
  const encryptedToken = localStorage.getItem('token');
  let decryptedToken = '';

  if (encryptedToken) {
    try {
      const decryptedBytes = CryptoJS.AES.decrypt(encryptedToken, secret_key);
      decryptedToken = decryptedBytes.toString(CryptoJS.enc.Utf8);
    } catch (error) {
      console.log('Error.');
    }
  }

  const token = `Bearer ${decryptedToken}`;

  if (storedData) {
    var bytes = CryptoJS.AES.decrypt(storedData, secret_key);
    var logeduserData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8)); 
  } 

  let navigate = useNavigate();

  useEffect(() => {
    Modal.setAppElement('#root');
  }, []);

  const fetchUsers = () => {
    const getUserssURL = `${API_URL}/get_users?page=${page}&limit=${50}`;
    let getUsersConfig = {
      method: 'get',
      maxBodyLength: Infinity,
      url: getUserssURL,
      headers: { 
        'Authorization': token
      }
    };

    axios
      .request(getUsersConfig)
      .then(function (response) {
        if (response.data.length === 0) {
          setHasMore(false);
        } else {
          setUsers([...users, ...response.data]);
          setPage(page + 1);
        }
      })
      .catch(function (error) {
        // handle errors
         if (error?.response?.status === 401) {
          navigate(0);
        }
      });
  };

  useEffect(() => {
    fetchUsers();
  });

  const handleSearch = (event) => {
    setSearchTerm(event.target.value);
    fetchUsers();
  };

  const filteredUsers = users.filter((user) => {
    const { id, full_name, email, company_name } = user;
    const lowerCaseSearchTerm = searchTerm.toLowerCase();
    return (
      id.toString().toLowerCase().includes(lowerCaseSearchTerm) ||
      full_name.toLowerCase().includes(lowerCaseSearchTerm) ||
      company_name.toLowerCase().includes(lowerCaseSearchTerm) ||
      email.toLowerCase().includes(lowerCaseSearchTerm)
    );
  });

  const loadMoreUsers = () => {
    fetchUsers(); // Fetch more users when the user scrolls to the bottom
  };

  const fetchCompanies = () => {
    let config = {
      method: 'get',
      maxBodyLength: Infinity,
      url: `${API_URL}/get_companies`,
      headers: { 
        'Authorization': token
      }
    }
    
    axios.request(config)
    .then((response) => {
      const formattedOptions = response.data.map((company) => ({
        value: company.id,
        label: company.id+". "+company.name
      }));
      setCompany(formattedOptions);
    })
    .catch((error) => {
      console.log(error?.response)
    });
  };
  useEffect(() => {
    fetchCompanies();
  }, []);

  const [modalIsOpen, setIsOpen] = useState(false);

    const openModal = () => {
      setIsOpen(true);
    }
  
    const closeModal = () => {
      setIsOpen(false);
    }

  const [userdata, setnewUserData] = useState({
    user_name: "",
    full_name: "",
    email: "",
    password: "",
    company_id: ""
  });

  const handleChange = (e) =>{
    const newdata = { ...userdata }
    newdata[e.target.id] = e.target.value
    setnewUserData(newdata)
  } 

  const [isSubmitting, setIsSubmitting] = useState(false);
  const registerUser = (ev) => {
    ev.preventDefault();

    if (isSubmitting) {
      return;
    }

    setIsSubmitting(true);

    let config = {
      method: 'post',
      maxBodyLength: Infinity,
      url: `${API_URL}/signup`,
      headers: { 
        'Content-Type': 'application/json',
        'Authorization': token
      },
      data : userdata
    };
    
    axios.request(config)
    .then((response) => {
      Swal.fire({
        icon: "success",
        title: "Success!",
        text: "New user was created successfully",
      })
      .then(() => {
        navigate(0);
      });
      setIsSubmitting(false);
    })
    .catch((error) => {
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: error?.response?.data?.error,
      })
      setIsSubmitting(false);
    });
  }


  const deleteUser = (userid) => {
    Swal.fire({
      title: 'Are you sure you want to delete?',
      text: 'This action cannot be undone.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Delete',
      cancelButtonText: 'Cancel',
    }).then((result) => {
      if (result.isConfirmed) {
        let config = {
          method: 'delete',
          maxBodyLength: Infinity,
          url: `${API_URL}/delete_user/${userid}`,
          headers: {
            'Authorization': token
          }
        };
        
        axios.request(config)
        .then((response) => {
          setTimeout(() => {
            Swal.fire({
              title: 'Deleted!',
              text: 'The user has been deleted.',
              icon: 'success',
              timer: 2000,
              timerProgressBar: true,
              showConfirmButton: false
            })
            .then(() => {
              navigate(0);
            });
          }, 1000);
        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            title: "Error!",
            text: error?.response?.data?.error,
          })
        });
      }
    });
  }


const disableUser = (userid) => {
  let config = {
    method: 'put',
    maxBodyLength: Infinity,
    url: `${API_URL}/disable_user/${userid}`,
    headers: {
      'Authorization': token
     }
  };
  
  axios.request(config)
  .then((response) => {
    Swal.fire({
      icon: "success",
      title: "Success!",
      text: "User has been deactivated",
    })
    .then(() => {
      navigate(0);
    });
  })
  .catch((error) => {
    Swal.fire({
      icon: "error",
      title: "Error!",
      text: error?.response?.data?.error,
    })
  });
}
const enableUser = (userid) => {
  let config = {
    method: 'put',
    maxBodyLength: Infinity,
    url: `${API_URL}/enable_user/${userid}`,
    headers: {
      'Authorization': token
     }
  };
  
  axios.request(config)
  .then((response) => {
    Swal.fire({
      icon: "success",
      title: "Success!",
      text: "User has been activated",
    })
    .then(() => {
      navigate(0);
    });
  })
  .catch((error) => {
    Swal.fire({
      icon: "error",
      title: "Error!",
      text: error?.response?.data?.error,
    })
  });
}


//edit modal
const [editmodalIsOpen, setEditIsOpen] = useState(false);
const [edituser, seteditUser] = useState({
  user_name: "",
  full_name: "",
  email: "",
  password: "",
  company_id: ""
});
const [usertoedit, setUsertoedit] = useState("");

const openEditModal = (userid) => {
  setEditIsOpen(true);
  setUsertoedit(userid)

    const getUserByID = () => {
      let config = {
        method: 'get',
        maxBodyLength: Infinity,
        url: `${API_URL}/get_user/${userid}`,
        headers: { 
          'Authorization': token
        }
      }
      
      axios.request(config)
      .then((response) => {
        seteditUser(response.data)  
        seteditUser((prevEditUser) => ({
          ...prevEditUser,
          company_id: { 
            value: response.data.company_id, 
            label: response.data.company_id + ". " + response.data.company_name 
          }
        }));       
      })
      .catch((error) => {
        console.log(error?.response)
      });
    };
    
    getUserByID();
}

const closeEditModal = () => {
  setEditIsOpen(false);
}

const handleeditChange = (e) => {
  const edituserdata = { ...edituser }
  edituserdata[e.target.id] = e.target.value
  seteditUser(edituserdata)
}

const handleCompanyChange = (selectedOption) => {
  seteditUser({
    ...edituser,
   company_id: { value: selectedOption.value, label: selectedOption.label }
  })
};

const editUserDetails =(e) => {
  e.preventDefault()

  let usereditedata = {
    ...edituser,
    company_id: edituser.company_id?.value
  }
  let config = {
    method: 'put',
    maxBodyLength: Infinity,
    url: `${API_URL}/edit_user/${usertoedit}`,
    headers: { 
      'Content-Type': 'application/json',
      'Authorization': token
    },
    data : usereditedata
  };
  
  // console.log(usereditedata)
  axios.request(config)
  .then((response) => {
    Swal.fire({
      icon: "success",
      title: "Success!",
      text: "User has been edited",
    })
    .then(() => {
      navigate(0)
    });
  })
  .catch((error) => {
    Swal.fire({
      icon: "error",
      title: "Error!",
      text: error?.response?.data?.error,
    })
  });
}


//secret key modal
const [secretmodalIsOpen, setSecretModalIsOpen] = useState(false);
const [secretuserid, setsecretuserid] = useState("");

const [secretkeydata, setsecretkeydata] = useState({
  name: "",
  secret: ""
});

const openSecretModalModal = (userID) => {
  setSecretModalIsOpen(true);
  setsecretuserid(userID)
  
  let config = {
    method: 'get',
    maxBodyLength: Infinity,
    url: `${API_URL}/get_user_key/${userID}`,
    headers: { 
      'Authorization': token
    }
  };
  
  axios.request(config)
  .then((response) => {
    setsecretkeydata(response.data);
  })
  .catch((error) => {
    console.log(error?.response)
  });
}

const closeSecretModal = () => {
  setSecretModalIsOpen(false);
}

//generate secret key
const generateKey = (userID) => {
  let config = {
    method: 'put',
    maxBodyLength: Infinity,
    url: `${API_URL}/generate_key/${userID}`,
    headers: {
      'Authorization': token
     }
  };
  
  axios.request(config)
  .then((response) => {
    Swal.fire({
      icon: "success",
      title: "Success!",
      text: "Secret key has been generated",
    })
    .then(() => {
      navigate(0);
    });
  })
  .catch((error) => {
    Swal.fire({
      icon: "error",
      title: "Error!",
      text: error?.response?.data?.error,
    })
  });
}

  return (
    <div style={{ paddingLeft: '10px' }}>
      <div className="content-header">
            <div className="container-fluid">
              <div className="row mb-2">
                <div className="col-sm-6">
                  <h1 className="m-0">Users</h1>
                </div>{/* /.col */}
                <div className="col-sm-6">
                  <ol className="breadcrumb float-sm-right">
                    <li className="breadcrumb-item"><a href="/">Home</a></li>
                    <li className="breadcrumb-item active">Users</li>
                  </ol>
                </div>{/* /.col */}
              </div>{/* /.row */}
            </div>{/* /.container-fluid */}
        </div>

        <Modal
          isOpen={modalIsOpen}
          onRequestClose={closeModal}
          style={customStyles}
          contentLabel="Example Modal"
        >
          <div className="containernewcompany">
            <div className="title">
              New User
              <i onClick={closeModal} className="fa fa-window-close red-close-icon" aria-hidden="true"></i>
            </div>
            <div className="content">
              <form onSubmit={registerUser}>
                <div className="user-details">
                  <div className="input-box">
                    <span className="details">Username</span>
                    <input type="text" 
                      placeholder="Enter username" 
                      required 
                      onChange={handleChange}
                      id='user_name'
                    />
                  </div>
                  <div className="input-box">
                    <span className="details">Full Name</span>
                    <input type="text" 
                      placeholder="Enter full name" 
                      required 
                      onChange={handleChange}
                      id='full_name'
                    />
                  </div>
                  <div className="input-box">
                    <span className="details">Email</span>
                    <input type="email" 
                      placeholder="Enter email" 
                      required 
                      onChange={handleChange}
                      id='email'
                    />
                  </div>
                  <div className="input-box">
                    <span className="details">Password</span>
                    <input type="password" 
                      placeholder="Enter paswword"  
                      onChange={handleChange}
                      id='password'
                    />
                  </div>
                  <div className="input-box">
                    <span className="details">Company</span>
                    <Select
                      options={companies}
                      placeholder="Select company:"
                      onChange={(selectedOptions) =>
                        setnewUserData({
                          ...userdata,
                          company_id: selectedOptions.value
                        })
                      }
                      id='company_id'
                    />
                  </div>
                  
                </div>
               
                <div className="button">
                  <input type="submit" defaultValue="Register" />
                </div>
              </form>
            </div>
          </div>

        </Modal>


        <Modal
          isOpen={editmodalIsOpen}
          onRequestClose={closeEditModal}
          style={customStyles}
          contentLabel="Example Modal"
        >
          <div className="containernewcompany">
            <div className="title">
              Edit User
              <i onClick={closeEditModal} className="fa fa-window-close red-close-icon" aria-hidden="true"></i>
            </div>
            <div className="content">
              <form onSubmit={editUserDetails}> 
                <div className="user-details">
                 
                  <div className="input-box">
                    <span className="details">Username</span>
                    <input type="text" 
                      placeholder="Enter username" 
                      value={edituser.user_name}
                      required 
                      onChange={handleeditChange}
                      id='user_name'
                    />
                  </div>
                  <div className="input-box">
                    <span className="details">Full Name</span>
                    <input type="text" 
                      placeholder="Enter full name" 
                      value={edituser.full_name}
                      required 
                      onChange={handleeditChange}
                      id='full_name'
                    />
                  </div>
                  <div className="input-box">
                    <span className="details">Email</span>
                    <input type="email" 
                      placeholder="Enter email" 
                      required 
                      onChange={handleeditChange}
                      id='email'
                      value={edituser.email}
                    />
                  </div>
                  <div className="input-box">
                    <span className="details">Password</span>
                    <input type="password" 
                      placeholder="Enter password"  
                      onChange={handleeditChange}
                      id='password'
                    />
                  </div>

                  <div className="input-box">
                    <span className="details">Company</span>
                    <Select
                      options={companies}
                      placeholder="Select company:"
                      onChange={handleCompanyChange}
                      value={edituser.company_id}
                      id='company_id'
                    />
                  </div>
                  
                </div>
               
                <div className="button">
                  <input type="submit" defaultValue="Update" />
                </div>
              </form>
            </div>
          </div>

        </Modal>



        {/* <Modal
          isOpen={unitsmodalIsOpen}
          onRequestClose={closeUnitsModal}
          style={customStylesforUnits}
          contentLabel="Example Modal"
        >
          <div className="containernewcompany">
            <div className="title">
              Assign units to {unitsusername}
              <i onClick={closeUnitsModal} className="fa fa-window-close red-close-icon" aria-hidden="true"></i>
            </div>
            <form onSubmit={editUnitsDetails}> 
            <div className="content">
                <div className="user-details">

                  <div className="input-box">
                    <input type="hidden" 
                      className='unitsINPUT'
                      id='refrence_no'
                    />
                  </div> 
                 
                  <div className="input-box">
                    <span className="details">Units</span>
                    <input type="text" 
                      className='unitsINPUT'
                      required 
                      onChange={handleunitsChange}
                      id='amount'
                    />
                  </div>                  
                </div>
               
                <div className="button">
                  <input type="submit" defaultValue="Assign" />
                </div>
            </div>
            </form>
          </div>

        </Modal> */}


        <Modal
          isOpen={secretmodalIsOpen}
          onRequestClose={closeSecretModal}
          style={customStylesforUnits}
          contentLabel="Example Modal"
        >
          <div className="containernewcompany">
            <div className="title">
              Api secret for {secretkeydata?.name}
              <i onClick={closeSecretModal} className="fa fa-window-close red-close-icon" aria-hidden="true"></i>
            </div>
            <div className="content">
                <div className="user-details">                 
                  <div className="input-box">
                    <span className="details">Client ID</span>
                    <input type="text" 
                      className='unitsINPUT'
                      value={secretuserid}
                      readOnly
                      style={{ backgroundColor: 'rgba(0, 0, 0, 0.1)' }}
                    />
                  </div>                 
                </div>
                <div className="user-details">                 
                  <div className="input-box">
                    <span className="details">Secret Key</span>
                    <input type="text" 
                      className='unitsINPUT'
                      value={secretkeydata?.secret}
                      readOnly
                      style={{ 
                        backgroundColor: 'rgba(0, 0, 0, 0.1)',
                        overflowX: 'auto'
                      }}
                    />
                  </div>                 
                </div>

            </div>
          </div>

        </Modal>




      <form className="form-inline justify-content-end searchBar">
        <div id="add-btn" onClick={openModal}> <i className='fa fa-plus'></i>Add User</div>
        <div className="input-group input-group-sm">
          <input
            className="form-control form-control-navbar"
            type="search"
            placeholder="Search"
            aria-label="Search"
            value={searchTerm}
            onChange={handleSearch}
          />
        </div>
      </form>

          <InfiniteScroll

            dataLength={filteredUsers.length}
            next={loadMoreUsers}
            hasMore={hasMore}
            loader={filteredUsers.length > 0 ? null : 
              <div className="loadingsubcontainer">
                <img className="loadingsubimg" src={loading1} alt="" />
              </div>}
            endMessage={<p>No more users to load.</p>}
          >
            <table id="example" className="table table-striped">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Full Name</th>
                  <th>Email</th>
                  <th>Company</th>
                  <th>Status</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                  {filteredUsers.map((user) => (
                    <tr key={user.id}>
                      <td>{user.id}</td>
                      <td>{user.full_name}</td>
                      <td>{user.email}</td>
                      <td>{user.company_name}</td>
                      <td>{
                            user.status ? (
                              <p style={{color: 'green'}}>Active</p>
                            ) : (
                              <p style={{color: 'red'}}>Inactive</p>
                            )
                          }
                        </td>
                      <td className="dropdown">
                        <button className="btn btn-primary dropdown-toggle" type="button" data-toggle="dropdown">Action
                          <span className="caret" /></button>
                        <ul className="dropdown-menu companyActions">
                          {/* <li onClick={() => openUnitsModal(user.id, user.user_name)}><i className="fa fa-comment"></i>Assign units</li> */}
                          {
                           user.secret !== "" ? (
                              <li className='px-3 py-2 flex items-center gap-2 cursor-pointer hover:bg-gray-100' onClick={() => openSecretModalModal(user.id)}><i className="fa fa-key"></i>View key</li>
                            ) : (
                              <li onClick={() => generateKey(user.id)}><i className="fa fa-key"></i>Generate key</li>                            
                            )
                          }
                          <li className='px-3 py-2 flex items-center gap-2 cursor-pointer hover:bg-gray-100' onClick={() => openEditModal(user.id)}><i className="fa fa-edit"></i>Edit user</li>
                          {
                            user.email === logeduserData?.email ? (
                              <li className='px-3 py-2 flex items-center gap-2 cursor-pointer hover:bg-gray-100' style={{display: 'none'}}><i className="fa fa-minus-circle"></i>Disable user</li>
                            ) :
                            user.status ? (
                              <li className='px-3 py-2 flex items-center gap-2 cursor-pointer hover:bg-gray-100' onClick={() => disableUser(user.id)}><i className="fa fa-minus-circle"></i>Disable user</li>
                            ) : (
                              <li className='px-3 py-2 flex items-center gap-2 cursor-pointer hover:bg-gray-100' onClick={() => enableUser(user.id)}><i className="fa fa-toggle-on"></i>Enable user</li>
                            )
                          }

                          {
                            user.email === logeduserData?.email ? (
                              <li className='px-3 py-2 flex items-center gap-2 cursor-pointer hover:bg-gray-100' style={{display: 'none'}}><i className="fa fa-minus-circle"></i>Delete user</li>
                            ) : (
                              <li className='px-3 py-2 flex items-center gap-2 cursor-pointer hover:bg-gray-100' onClick={() => deleteUser(user.id)}><i className="fa fa-trash"></i>Delete user</li>                            
                            )
                          }
                        </ul>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
        </InfiniteScroll>
      
    </div>
  )
}

export default UserManagement